import type { AppRouteRecordRaw } from '@/router/types'
import { Layout } from '@/utils/routerHelper'

/**
 * AI智慧景区独立路由组
 * 正式前缀：/scenicarea/*（独立窗 app=scenicarea）
 * 侧栏业务菜单仍来自后端 /scenic/*（见 menuPaths）
 */
const scenicStandaloneRoutes: AppRouteRecordRaw[] = [
  {
    path: '/scenicarea',
    component: Layout,
    redirect: '/scenicarea/dashboard',
    name: 'ScenicStandalone',
    meta: { title: 'AI智慧景区', hidden: true },
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/scenic/dashboard/index.vue'),
        name: 'ScenicStandaloneDashboard',
        meta: { title: '景区概况', hidden: true, canTo: true }
      },
      {
        path: 'overview',
        component: () => import('@/views/scenic/overview/index.vue'),
        name: 'ScenicStandaloneOverview',
        meta: { title: '景区概况', hidden: true, canTo: true }
      },
      // 概况-快捷入口「移动端」跳转目标：模板装修（会由 buildAiApplicationCenterRoutes 自动生成 /ai-Application-center/scenicarea/template 前缀副本）
      {
        path: 'template',
        component: () => import('@/views/scenic/template/index.vue'),
        name: 'ScenicStandaloneTemplate',
        meta: { title: '模板装修', hidden: true, canTo: true }
      }
    ]
  }
]

export default scenicStandaloneRoutes
